import { isAxiosError } from 'axios';
import { getOnce, putOnce, deleteOnce } from '@/plugins/axios.js';
import InvalidPayload from '@/exceptions/InvalidPayload.js';
import { BusinessHourException } from '@/entities/types/BusinessHourException.ts';

interface ShowResponse {
    hasPrevious: boolean;
    hasNext: boolean;
    data: BusinessHourException[];
}

export const businessHoursExceptions = {
    show: async (
        accountId: number | string,
        params: Record<string, any> = {}
    ): Promise<ShowResponse | null> => {
        if (!accountId) {
            throw new InvalidPayload('ID not provided.');
        }

        try {
            return (await getOnce(
                `v1/accounts/${accountId}/business-hours-exceptions`,
                params
            )) as ShowResponse;
        } catch (error: unknown) {
            if (!isAxiosError(error)) {
                throw error;
            }

            const response = error.response;

            if (response && response.status === 404) {
                return null;
            }

            throw error;
        }
    },

    update: async (
        accountId: number,
        businessHoursExceptionsId: number,
        payload: Record<string, any>
    ) => {
        if (!accountId) {
            throw new InvalidPayload('ID not provided.');
        }

        try {
            return (await putOnce(
                `v1/accounts/${accountId}/business-hours-exceptions/${businessHoursExceptionsId}`,
                payload
            )) as ShowResponse;
        } catch (error: unknown) {
            if (!isAxiosError(error)) {
                throw error;
            }

            const response = error.response;

            if (response && response.status === 404) {
                return null;
            }

            throw error;
        }
    },

    delete: async (accountId: number, businessHoursExceptionsId: number) => {
        if (!accountId) {
            throw new InvalidPayload('ID not provided.');
        }

        try {
            return (await deleteOnce(
                `v1/accounts/${accountId}/business-hours-exceptions/${businessHoursExceptionsId}`,
                {}
            )) as ShowResponse;
        } catch (error: unknown) {
            if (!isAxiosError(error)) {
                throw error;
            }

            const response = error.response;

            if (response && response.status === 404) {
                return null;
            }

            throw error;
        }
    },
};
